import { EnvelopeOpenIcon } from '@heroicons/react/24/outline';
import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import { DateTime } from 'luxon';
import { formatDate } from '@/app/helpers/date.helpers.ts';
import type { NotificationMessage } from '../../types/notification-message.type.ts';

const NotificationMessageAlert = ({
  notification,
  isOpen,
  onClose,
}: {
  notification: NotificationMessage | null;
  isOpen: boolean;
  onClose: () => void;
}) => (
  <Modal
    isOpen={isOpen}
    placement='center'
    backdrop='blur'
    size='lg'
    onClose={onClose}
    classNames={{
      base: 'overflow-hidden border border-zinc-200 shadow-2xl dark:border-zinc-700',
      closeButton:
        'top-3 right-3 text-zinc-500 hover:bg-white/70 hover:text-zinc-950 dark:hover:bg-zinc-800 dark:hover:text-white',
    }}
  >
    <ModalContent>
      <ModalHeader className='relative flex items-start gap-3 overflow-hidden border-b border-primary-100 bg-gradient-to-br from-primary-50 via-white to-secondary-50 px-6 py-5 dark:border-zinc-700 dark:from-primary-950/60 dark:via-zinc-900 dark:to-secondary-950/30'>
        <span className='flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700 ring-1 ring-primary-200 dark:bg-primary-900/50 dark:text-primary-300 dark:ring-primary-800'>
          <EnvelopeOpenIcon className='size-5' />
        </span>
        <span>
          <span className='block text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-secondary-600 dark:text-secondary-400'>
            Notification
          </span>
          <span className='mt-1 block font-serif text-lg font-semibold text-zinc-950 dark:text-white'>
            Message details
          </span>
        </span>
      </ModalHeader>
      <ModalBody className='px-6 py-6'>
        <time
          dateTime={notification?.sentAt}
          className='text-xs font-medium uppercase tracking-[0.12em] text-zinc-400'
        >
          Sent {formatDate(notification?.sentAt, DateTime.DATETIME_SHORT)}
        </time>
        <Divider className='my-4' />
        <div
          className='text-sm leading-6 text-zinc-700 [&_a]:font-medium [&_a]:text-primary-600 [&_p]:mb-3 [&_p:last-child]:mb-0 dark:text-zinc-300'
          dangerouslySetInnerHTML={{ __html: notification?.message ?? '' }}
        />
      </ModalBody>
      <ModalFooter className='border-t border-zinc-100 bg-zinc-50 px-6 py-3 dark:border-zinc-800 dark:bg-zinc-900'>
        <Button color='primary' variant='solid' onPress={onClose}>
          Done
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default NotificationMessageAlert;
